import { render, staticRenderFns } from "./CleanerPanel.vue?vue&type=template&id=2718fdfc&scoped=true"
import script from "./CleanerPanel.vue?vue&type=script&lang=js"
export * from "./CleanerPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718fdfc",
  null
  
)

export default component.exports